var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.782.587c-9.28-1.7-16.696.295-22.247 5.985C5.985 12.262 2.14 18.222 0 24.452l9.878 10.033c10.125-3.849 17.017-8.879 20.677-15.09S35.291 6.915 33.782.587z",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.119 24.834c-2.891 2.394-4.806 4.935-5.745 7.624C-.034 36.492.033 39.695.5 40.428c.467.733 5.475.733 8.707-.87 2.155-1.068 4.46-2.925 6.915-5.573l-9.003-9.151z",
    fill: "#FFE137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.887 23.678c.217 2.756-.389 5.609-1.818 8.558-2.143 4.424-5.55 6.65-6.43 6.65-.587 0-1.861-2.217-3.824-6.65l12.072-8.558zM8.816 19.169c-4.256-1.707-6.489-2.94-6.697-3.7-.312-1.14 2.977-5.006 7.244-6.974 2.845-1.312 5.613-1.814 8.304-1.508L8.817 19.17z",
    fill: "#005776"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.557)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.393 1.048c-.227 3.674 1 6.696 3.681 9.067 2.681 2.37 5.72 3.555 9.115 3.555l3.087-4.665-1.448-9.782-12.598-.679-1.837 2.504z",
    fill: "#009ED7",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.278 10.06)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#009ED7",
    cx: 5.432,
    cy: 5.432,
    r: 5.432
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#48CFFF",
    cx: 5.432,
    cy: 5.432,
    r: 3.018
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M7.713 31.458 18.25 20.922a1 1 0 0 1 1.414 0l.293.293a1 1 0 0 1 0 1.414L9.42 33.166a1 1 0 0 1-1.414 0l-.293-.293a1 1 0 0 1 0-1.415z",
    fill: "#009ED7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.ba76cb1b8917f7ee837756e0f238e1a8.svg";
export { ForwardRef as ReactComponent };